<template>
  <div>
    <div class="oSaixuan">
      <div class="item" v-for="(item,index) in resume_list" :key="index">
        <div class="title">{{item.title}}</div>
        <div class="oType" v-if="item.name !== 'limit'">
          <div
            @click="setType(index,item,item1)"
            v-for="(item1,index1) in item.options"
            :key="index1"
            :class="{ blue: item.selected && item.selected[item1] }"
          >{{item1}}</div>
        </div>
        <div class="value" v-else>
          <InputNumber
            class="salary-input"
            v-model="low_limit"
            :min="0"
            @on-change="isCustom = false"
            type="number"
            style="color: #333;"
            placeholder="请输入薪资"
            placeholder-style="color:#ccc"
          />
          <span style="margin:0 10px">-</span>
          <InputNumber
            class="salary-input"
            v-model="up_limit"
            :min="0"
            @on-change="isCustom = false"
            type="number"
            style="color: #333;"
            placeholder="请输入薪资"
            placeholder-style="color:#ccc"
          />
          <span class="custom" :class="{ actived: isCustom }" @click="handelCustom">面议</span>
        </div>
      </div>
      <div class="btns">
        <div @click="close">重置</div>
        <div @click="confirm">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "filtrate",
  props: {
    resume_list: [Object, Array]
  },
  data() {
    return {
      isCustom: false,
      low_limit: 0,
      up_limit: 0
    };
  },
  methods: {
    setType(index, item, item1) {
      if (!this.resume_list[index].selected) {
        this.resume_list[index].selected = {};
      }
      if (this.resume_list[index].selected[item1]) {
        delete this.resume_list[index].selected[item1];
        this.$forceUpdate();
      } else {
        if (item.type === "single") {
          this.resume_list[index].selected = {};
        }
        // this.$set(this.resume_list[index].selected,item1, true);
        this.resume_list[index].selected[item1] = true;
        this.$forceUpdate();
      }
    },
    handelCustom() {
      this.isCustom = !this.isCustom;
      if (this.isCustom) {
        this.up_limit = 0;
        this.low_limit = 0;
      }
    },
    confirmSalary() {
      // 筛选的是数组
      if (this.resume_list instanceof Array) {
        this.resume_list.forEach(item => {
          if (item.name === "limit") {
            item.selected = {};
            if (this.isCustom) {
              item.selected = { 面议: true };
            } else {
              if (this.up_limit == this.low_limit && this.up_limit == 0) {
                return;
              }
              if (this.up_limit == null) {
                this.up_limit = 0;
              }
              if (this.low_limit == null) {
                this.low_limit = 0;
              }
              if (Number(this.up_limit) < Number(this.low_limit)) {
                [this.low_limit, this.up_limit] = [
                  this.up_limit,
                  this.low_limit
                ];
              }
              let key = this.low_limit + "-" + this.up_limit;
              item.selected[key] = true;
            }
          }
        });
        return;
      }
      // 筛选额是对象
      this.resume_list.limit.selected = {};
      if (this.isCustom) {
        this.resume_list.limit.selected["面议"] = true;
      } else {
        if (Number(this.up_limit) < Number(this.low_limit)) {
          [this.low_limit, this.up_limit] = [this.up_limit, this.low_limit];
        }
        let key = this.low_limit + "-" + this.up_limit;
        this.resume_list.limit.selected[key] = true;
      }
    },
    confirm() {
      this.confirmSalary();
      this.$emit("confirm", this.resume_list);
    },
    close() {
      // this.$emit("close");
      //清除选中内容
      if (this.resume_list instanceof Array) {
        this.resume_list.forEach((item, index) => {
          this.$delete(item, "selected");
        });
      } else {
        for (let element in this.resume_list) {
          if (this.resume_list[element].selected) {
            this.$delete(this.resume_list[element], "selected");
          }
        }
      }
      this.isCustom = false;
      this.low_limit = 0;
      this.up_limit = 0;
    }
  }
};
</script>

<style lang="less" scoped>
.oSaixuan {
  width: 100%;
  height: 569px;
  padding: 20px 40px;
  box-sizing: border-box;
  > .item {
    > .title {
      margin-top: 18px;
      font-size: 16px;
      color: #363e4f;
    }
    .value {
      margin-top: 10px;
    }
    > .oType {
      > div {
        display: inline-block;
        padding: 5px 10px;
        margin-right: 3%;
        margin-top: 10px;
        color: rgba(54, 62, 79, 0.4);
        border: 1px solid rgba(54, 62, 79, 0.4);
        border-radius: 12.5px;
        font-size: 12px;
        cursor: pointer;
      }
      .blue {
        background: #d6000f;
        border: 1px solid #fff;
        color: #fff;
      }
    }
  }
  > .item::after {
    content: "";
    display: block;
    clear: both;
    height: 0;
  }
  .btns {
    display: flex;
    margin-top: 55px;
    float: right;

    > div {
      width: 102px;
      height: 34px;
      text-align: center;
      line-height: 34px;
      cursor: pointer;
    }
    > div:first-child {
      border: 1px solid #d6000f;
      color: #d6000f;
      margin-right: 10px;
    }
    > div:last-child {
      background: #d6000f;
      color: #fff;
    }
  }
}
.custom {
  display: inline-block;
  width: 80px;
  height: 32px;
  text-align: center;
  border-radius: 12.5px;
  line-height: 30px;
  margin-left: 20px;
  color: rgba(54, 62, 79, 0.4);
  border: 1px solid rgba(54, 62, 79, 0.4);
  cursor: pointer;
  &.actived {
    background-color: #d6000f;
    color: #fff;
  }
}
</style>